// extracted by css-extract-rspack-plugin
export default {"cls1":"Link-cls1_8Wo","cls2":"Link-cls2_LEg Link-cls1_8Wo"};